/**
 * Clés localStorage du mode maintenance rattachées à un conseiller, dans un module FEUILLE (aucun import) :
 * `auth/useAuth.ts` les purge au changement d'identité sans importer `useMaintenance.ts`, qui importe
 * `auth/api.ts`, qui importe `auth/useAuth.ts` (cycle d'imports).
 */

/** Route mémorisée à l'entrée en maintenance, restaurée à sa sortie. */
export const STORAGE_RETURN_TO = 'sapiendo.maintenance.returnTo'
